import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const contactDetails = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    phoneType: z
      .enum(['Mobile', 'Landline'])
      .nullable()
      .optional()
      .describe('Primary phone type.'),

    phoneNumber: z
      .string()
      .nullable()
      .optional()
      .describe('Primary phone number with country code.'),

    otherPhoneType: z
      .enum(['Mobile', 'Landline'])
      .nullable()
      .optional()
      .describe('Secondary phone type.'),

    otherPhoneNumber: z
      .string()
      .nullable()
      .optional()
      .describe('Secondary phone number with country code.'),

    email: z.string().nullable().optional().describe('Email address.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Phone numbers and email for a candidate.')
  .as('ContactDetails');

export { contactDetails as contactDetailsSchema };
